// Ниши › list — every vertical row, what it has produced, and the switch that makes it run.

import { useState } from 'react';
import {
  useCreateVertical,
  useUpdateVertical,
  useVerticalCounts,
  type VerticalRow,
} from './useVerticals.js';

const ORIGIN_LABEL: Record<string, string> = {
  seed: 'вградена',
  preset: 'шаблон',
  llm: 'предложена от модел',
  manual: 'ръчна',
};

function NewVerticalForm({ onDone }: { onDone: () => void }) {
  const create = useCreateVertical();
  const [key, setKey] = useState('');
  const [nameBg, setNameBg] = useState('');
  const [nameEn, setNameEn] = useState('');
  const keyOk = /^[a-z][a-z0-9_]{1,40}$/.test(key);

  return (
    <form
      className="adm__row-edit adm__row-edit--form"
      onSubmit={(event) => {
        event.preventDefault();
        create.mutate({ key, name_bg: nameBg, name_en: nameEn }, { onSuccess: onDone });
      }}
    >
      <input
        type="text"
        className="adm__input adm__input--mono adm__input--short"
        value={key}
        onChange={(event) => setKey(event.target.value.trim())}
        placeholder="ключ (lawyer)"
        aria-label="Ключ"
      />
      <input
        type="text"
        className="adm__input"
        value={nameBg}
        onChange={(event) => setNameBg(event.target.value)}
        placeholder="Име (бг)"
        aria-label="Име на български"
      />
      <input
        type="text"
        className="adm__input"
        value={nameEn}
        onChange={(event) => setNameEn(event.target.value)}
        placeholder="Name (en)"
        aria-label="Име на английски"
      />
      <button
        type="submit"
        className="adm__resolve-btn"
        disabled={!keyOk || nameBg.trim() === '' || nameEn.trim() === '' || create.isPending}
      >
        Създай неактивна
      </button>
      <button type="button" className="adm__json-btn" onClick={onDone}>
        Отказ
      </button>
      {create.isError ? <span className="adm__err">{(create.error as Error).message}</span> : null}
    </form>
  );
}

export function VerticalsList({
  verticals,
  onOpen,
}: {
  verticals: VerticalRow[];
  onOpen: (key: string) => void;
}) {
  const toggle = useUpdateVertical();
  const [creating, setCreating] = useState(false);
  const { data: counts = {} } = useVerticalCounts(verticals.map((v) => v.key));

  return (
    <div className="adm__queries-wrap">
      <div className="adm__section-header">
        <h3 className="adm__h">Ниши</h3>
        <span className="adm__sub">
          Една ниша е ред: речник, филтър, тежест на проверките и въпроси. Шаблоните стоят
          изключени, докато не ги активирате.
        </span>
      </div>

      <div className="adm__tablewrap">
        <table className="adm__table">
          <thead>
            <tr>
              <th>ниша</th>
              <th>ключ</th>
              <th>произход</th>
              <th className="adm__num">заявки</th>
              <th className="adm__num">обекти</th>
              <th>активна</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {verticals.map((row) => (
              <tr key={row.key} className={row.active ? '' : 'adm__row--off'}>
                <td>
                  <strong>{row.name_bg}</strong>
                  <span className="adm__sub"> {row.name_en}</span>
                </td>
                <td>
                  <code>{row.key}</code>
                </td>
                <td>{ORIGIN_LABEL[row.origin] ?? row.origin}</td>
                <td className="adm__num">{counts[row.key]?.queries ?? '…'}</td>
                <td className="adm__num">{counts[row.key]?.leads ?? '…'}</td>
                <td>
                  <label className="adm__toggle-label">
                    <input
                      type="checkbox"
                      className="adm__toggle-check"
                      checked={row.active}
                      onChange={(event) =>
                        toggle.mutate({ key: row.key, patch: { active: event.target.checked } })
                      }
                      aria-label={`Активна: ${row.name_bg}`}
                    />
                    <span className="adm__toggle-state">{row.active ? 'Активна' : 'Спряна'}</span>
                  </label>
                </td>
                <td>
                  <button type="button" className="adm__json-btn" onClick={() => onOpen(row.key)}>
                    Редакция
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {toggle.isError ? <p className="adm__err">{(toggle.error as Error).message}</p> : null}

      <div className="adm__actions">
        {creating ? (
          <NewVerticalForm onDone={() => setCreating(false)} />
        ) : (
          <button type="button" className="adm__json-btn" onClick={() => setCreating(true)}>
            + Нова ниша от нулата
          </button>
        )}
      </div>
    </div>
  );
}
